var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(-790.000000, -274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "track",
    transform: "translate(620.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-circle",
    transform: "translate(170.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FE815F",
    cx: 39.9742522,
    cy: 39.9742522,
    r: 39.9742522
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.251669, 19.974252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0273245,27.8732025 C35.0273245,34.4706074 29.5988474,39.8188608 22.9024814,39.8188608 L5.09694629e-13,39.8188608 L5.09694629e-13,31.8550886 L22.9024814,31.8550886 C25.1346034,31.8550886 26.9440958,30.0723375 26.9440958,27.8732025 C26.9440958,25.6740676 25.1346034,23.8913165 22.9024814,23.8913165 L14.8192527,23.8913165 L14.8192527,15.9275443 L22.9024814,15.9275443 C25.1346034,15.9275443 26.9440958,14.1447932 26.9440958,11.9456582 C26.9440958,9.74652327 25.1346034,7.96377215 22.9024814,7.96377215 L5.09694629e-13,7.96377215 L5.09694629e-13,1.52596785e-11 L22.9024814,1.52596785e-11 C29.5988474,1.52596785e-11 35.0273245,5.34825336 35.0273245,11.9456582 C35.0273245,15.0051581 33.8598898,17.7960185 31.9399616,19.9094304 C33.8598898,22.0228423 35.0273245,24.8137027 35.0273245,27.8732025 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.800000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67088889e-14,31.8550886 L19.6708672,31.8550886 C15.4925095,36.690877 8.84006228,39.8188608 1.34720479,39.8188608 C0.894955156,39.8188608 0.445767153,39.8074655 2.67088889e-14,39.7849871 L2.67088889e-14,31.8550886 L2.67088889e-14,31.8550886 Z M23.7915536,23.8913165 L16.1664575,23.8913165 L16.1664575,15.9275443 L23.7915536,15.9275443 C24.0919785,17.2141313 24.2496862,18.5457704 24.2496862,19.9094304 C24.2496862,21.2730903 24.0919785,22.6047295 23.7915536,23.8913165 Z M19.6708672,7.96377215 L1.45134707e-12,7.96377215 L1.45134707e-12,0.0338736441 C0.445767153,0.0113953059 0.894955156,0 1.34720479,0 C8.84006228,0 15.4925095,3.12798374 19.6708672,7.96377215 L19.6708672,7.96377215 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.119999997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65179814e-13,1.52774844e-11 C11.1606099,1.52774844e-11 20.2080718,8.9137556 20.2080718,19.9094304 C20.2080718,30.9051052 11.1606099,39.8188608 4.65179814e-13,39.8188608 L4.65179814e-13,31.8550886 C6.69636594,31.8550886 12.1248431,26.5068352 12.1248431,19.9094304 C12.1248431,13.3120255 6.69636594,7.96377215 4.65179814e-13,7.96377215 L4.65179814e-13,1.52774844e-11 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.3e856f908443b6c7dde8feee0faa0d62.svg";
export { ForwardRef as ReactComponent };